// extracted by css-extract-rspack-plugin
export default {"popover-wrapper":"A7gR9E","popoverWrapper":"A7gR9E","root":"mTBhrk"};